<template>
  <section class="gallery-section" id="gallery">
    <div class="container">
      <h2>Gallery</h2>
      <Carousel
        :perPage="slidesPerView"
        :loop="true"
        :autoplay="autoplayOptions"
        :navigation-enabled="true"
        :pagination-enabled="true"
        class="myCarousel"
      >
        <Slide v-for="(image, index) in galleryImages" :key="index">
          <img
            :src="image.src"
            :alt="image.title"
            class="gallery-image"
            @click="openModal(index)"
            loading="lazy"
          />
        </Slide>
        <template #addons>
          <Navigation />
          <Pagination />
        </template>
      </Carousel>

      <!-- Modal -->
      <v-dialog
        v-model="isModalOpen"
        max-width="80%"
        @keydown.right="nextImage"
        @keydown.left="previousImage"
      >
        <v-card>
          <v-img
            :src="currentImage.src"
            :alt="currentImage.title"
            aspect-ratio="16/9"
          ></v-img>
          <v-card-title>{{ currentImage.title }}</v-card-title>
          <v-card-text>{{ currentImage.description }}</v-card-text>
          <v-card-actions>
            <v-btn text @click="previousImage">Previous</v-btn>
            <v-spacer></v-spacer>
            <v-btn text @click="nextImage">Next</v-btn>
            <v-spacer></v-spacer>
            <v-btn color="primary" text @click="isModalOpen = false">
              Close
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
  </section>
</template>

<script>
import { Carousel, Slide, Pagination, Navigation } from "vue3-carousel";
import "vue3-carousel/dist/carousel.css"; // Keep this import in script

// Import your images
import pgBase from "@/assets/pg_Base.png";
import pgEdit from "@/assets/pg_Edit.png";
import pgNew from "@/assets/pg_New.png";
import pgGenerate from "@/assets/pg_new_generatepassword.png";
import pgSettings from "@/assets/pg_Settings.png";
import pgThemeI from "@/assets/pg_ThemeChangeI.png";
import pgThemeII from "@/assets/pg_ThemeChangeII.png";

export default {
  name: "ImageGallery",
  components: {
    Carousel,
    Slide,
    Pagination,
    Navigation,
  },
  data() {
    return {
      slidesPerView: 3,
      galleryImages: [
        {
          src: pgBase,
          title: "Passguard9000",
          description: "Quick view",
        },
        {
          src: pgEdit,
          title: "Edit Display",
          description: "Edit the password",
        },
        {
          src: pgNew,
          title: "New Password",
          description: "Add a password",
        },
        {
          src: pgGenerate,
          title: "Password Generator",
          description: "Generate a random password",
        },
        {
          src: pgSettings,
          title: "Settings Page",
          description: "Configure settings",
        },
        {
          src: pgThemeI,
          title: "Themes",
          description: "Choose from 18 themes!",
        },
        {
          src: pgThemeII,
          title: "Themes",
          description: "Choose from 18 themes!",
        },
      ],
      isModalOpen: false,
      currentIndex: 0,
    };
  },
  computed: {
    currentImage() {
      return this.galleryImages[this.currentIndex];
    },
  },
  methods: {
    openModal(index) {
      this.currentIndex = index;
      this.isModalOpen = true;
    },
    nextImage() {
      this.currentIndex = (this.currentIndex + 1) % this.galleryImages.length;
    },
    previousImage() {
      this.currentIndex =
        (this.currentIndex - 1 + this.galleryImages.length) %
        this.galleryImages.length;
    },
  },
};
</script>

<style>
@import "@/styles/components/Gallery.scss";
</style>
